<template lang="pug">
    include DashboardPassword.pug
</template>

<script>
import _ from "underscore";
import Api from "@/components/services/Api";

export default {
  name: 'DashboardPassword',
  data() {
    return {
      user: null,
      showFormPersonal: false,
      showFormAddress: false,
      showFormCredentials: false,
      showFormPhoto: false,
      oldPassword: "",
      password: "",
      password2: "",
      token: null,
      image: null,
    }
  },
  computed: {
    currentUrl: function() {
      return window.location.href.split("#")[0];
    },
    avatarAction: function() {
      return Api.getApiUrl() + "/esreps/avatar-update/";
    }
  },
  created() {
    const _this = this;
    this.token = this.$store.state.token;

    Api.me(this.$store.state.token).then(response => {
      _this.user = response.data
      _this.image = _this.user.image
    }).catch(err => {
    });
  },
  filters: {
    genderhuman(value) {
      let map = {
        male: "Hombre",
        female: "Mujer",
        other: "Otro",
      }

      if (map.hasOwnProperty(value)) return map[value];
      return value;
    }
  },
  methods: {
    save() {
      const _this = this;
      let postObject = {};
      console.log(_this.password, _this.password2);

      if ( !_this.password.length || !_this.password2.length || _this.password != _this.password2 ) {
        _this.$notify({
          group: "esreps",
          title: "Error",
          type: "warn",
          text: "Las contraseñas deben coincidir"
        });
        return;
      }

      postObject = _.extend(postObject, {
        oldPassword: _this.oldPassword,
        password: _this.password
      })

      Api.updatePassword(postObject, this.$store.state.token).then(response => {
        _this.$notify({
          group: "esreps",
          title: "Mensaje",
          text: "Los cambios del formulario se han guardado correctamente"
        });
        this.oldPassword = undefined;
        this.password = undefined;
        this.password2 = undefined;
      }).catch(err => {
        _this.$notify({
          group: "esreps",
          title: "Error",
          type: "warn",
          text: "Error al actualizar la contraseña"
        });
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../styles/common_forms";
@import "Dashboard";
</style>




// WEBPACK FOOTER //
// src/components/dashboard/DashboardPassword.vue